import React from "react";

const WireDiagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 21}
    height={props?.height || 20}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.16669 4.16927C2.16669 3.25484 2.91893 2.50261 3.83335 2.50261H17.1667C18.0811 2.50261 18.8334 3.25484 18.8334 4.16927V15.8359C18.8334 16.7504 18.0811 17.5026 17.1667 17.5026H3.83335C2.91893 17.5026 2.16669 16.7504 2.16669 15.8359V4.16927ZM4.50002 5.83594V14.1693H16.5V5.83594H4.50002Z"
      fill="#4B68C6"
    />
    <circle cx="6.33335" cy="7.50261" r="0.833333" fill="#4B68C6" />
    <circle cx="14.6667" cy="7.50261" r="0.833333" fill="#4B68C6" />
    <circle cx="6.33335" cy="12.5026" r="0.833333" fill="#4B68C6" />
    <circle cx="14.6667" cy="12.5026" r="0.833333" fill="#4B68C6" />
    <path
      d="M7.16669 7.50261H13.8334"
      stroke="#4B68C6"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M7.16669 12.5026H13.8334"
      stroke="#4B68C6"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M6.33335 8.33594V11.6693"
      stroke="#4B68C6"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M14.6667 8.33594V11.6693"
      stroke="#4B68C6"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default WireDiagram;
